module.exports = __webpack_public_path__ + "static/media/card.e45a70b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/portland/card.jpg
// module id = 929
// module chunks = 27